/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';
import { groupBy } from 'lodash';

@Pipe({ name: 'laGroup' })
export class GroupPipe implements PipeTransform {
  transform<T extends { [key: string]: any }>(collection: T[], property: string): { name: string; data: T[] }[] {
    const groupedCollection = groupBy(collection, (element) => {
      if (Array.isArray(element[property])) {
        return element[property][0] || 'Unknown';
      }

      return element[property] || 'Unknown';
    });

    return Object.keys(groupedCollection)
      .sort()
      .map((key) => ({ name: key, data: groupedCollection[key] }));
  }
}
